export default __webpack_public_path__ + "static/scznyy_hover-8b766f0565f0ac98ea2d11ebc312f390.png";